module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp04-f9a8f0ed64e4157c1b29536c2d06a358.jpg";